import CommandeDetail from "../../../components/CommandeDetail";

const IDLE_RELEASE_NOTICE = "Le verrou a été libéré pour inactivité. Interagissez avec la page pour tenter de reprendre la main.";
const READ_ONLY = () => {};

// Commande ouverte : en-tête et actions du détail, puis éditeur fourni par l'écran. Sans le verrou, la saisie est
// désactivée et un calque bloque tout clic sur l'éditeur.
function OpenCommande({ vm }) {
    const {
        context, refresh, commandeDetail, draft, effectiveHasLock, updateDraft, setWorkflowDraft, setSelectedOrdonnance, handleBack,
        renderDetailActions, goToList, save, saveDraft, isDirty, handleCommandeUpdated, handleFavoriteChange,
        setDeleteConfirmationCommand, lockedBy, idleReleased, autoSaveStatus, saveErrors, children,
    } = vm;
    const setDraft = effectiveHasLock ? updateDraft : READ_ONLY;
    const lockedByUser = !effectiveHasLock && lockedBy ? lockedBy : null;
    const lockReleasedByInactivity = !effectiveHasLock && idleReleased;
    return (
        <>
            <CommandeDetail
                commande={commandeDetail}
                draft={draft}
                setDraft={setDraft}
                onSelectOrdonnance={setSelectedOrdonnance}
                onBack={handleBack}
                extraActions={renderDetailActions ? renderDetailActions({
                    commande: { ...commandeDetail, ...draft },
                    goToList,
                    refresh,
                    save,
                    saveDraft,
                    isDirty,
                    lockedByUser,
                }) : null}
                onUpdate={handleCommandeUpdated}
                onFavoriteChange={handleFavoriteChange}
                lockStatut={!!context.lockStatut}
                noPharmaceuticalValidation={!!context.noPharmaceuticalValidation}
                allowWorkflowActionsWhenLocked={!!context.allowWorkflowActionsWhenLocked}
                isDirty={isDirty}
                onSave={save}
                onDelete={setDeleteConfirmationCommand}
                lockedByUser={lockedByUser}
                lockNotice={lockReleasedByInactivity ? IDLE_RELEASE_NOTICE : null}
                autoSaveStatus={autoSaveStatus}
                saveErrors={saveErrors}
            />

            {/* Overlay bloquant tout clic sur le form si le mail est locké */}
            <div className="commande-detail-editor-region" style={{ flex: 1, minHeight: 0, overflow: "hidden", position: "relative" }}>
                {children && children({
                    commande: commandeDetail,
                    draft,
                    setDraft,
                    setWorkflowDraft,
                    saveDraft,
                    isDirty,
                    save,
                    refresh,
                    lockedByUser,
                    lockReleasedByInactivity,
                })}
                {!context?.allowWorkflowActionsWhenLocked && !effectiveHasLock && (lockedBy || idleReleased) && (
                    <div style={{
                        position: "absolute", inset: 0,
                        cursor: "not-allowed", zIndex: 10,
                    }} />
                )}
            </div>
        </>
    );
}

// Détail de la commande ouverte, affiché une fois la commande et son brouillon chargés.
export function CommandeDetailView({ vm }) {
    const { selectedCommande, commandeDetail, draft } = vm;
    return (
        <div className="commande-detail-page" style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
            {selectedCommande && commandeDetail && draft ? (
                <OpenCommande vm={vm} />
            ) : (
                <div style={{ padding: 40, color: "#94a3b8" }}>Chargement…</div>
            )}
        </div>
    );
}
